import { render, staticRenderFns } from "./TerminalPage.vue?vue&type=template&id=284c4fb8&"
import script from "./TerminalPage.vue?vue&type=script&lang=js&"
export * from "./TerminalPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TerminalPage.vue"
export default component.exports